import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { BuilderService } from 'src/app/builder-services/builder.service'
import { SettingsApiService } from 'src/app/builder-services/api/settings.api.service'

@Injectable({
  providedIn: 'root'
})
export class PostsService {
  constructor(
    private builderService: BuilderService,
    private settingsApi: SettingsApiService
  ) {}

  submitPost = (post: any, post_id: string = '') => {
    let project_id = this.builderService.selectedProject
    post = JSON.parse(JSON.stringify(post))
    const key = post_id || String(Date.now())
    return new Observable<any>((observer) => {
      this.settingsApi.upsertSettingsByType(String(project_id), 'posts', { [key]: JSON.stringify(post) })
        .then(() => {
          observer.next({ key }) // Notify the observer that the operation is complete
          observer.complete() // Complete the Observable
        })
        .catch((error) => {
          observer.error(error) // Notify the observer of an error
        })
    })
  }

  getPosts = () => {
    let project_id = this.builderService.selectedProject
    return new Observable<any>((observer) => {
      this.settingsApi.getSettingsByType(String(project_id), 'posts').then(
        (response) => {
          if (!response || !Object.keys(response).length) {
            console.log('No data available')
            observer.next({})
            observer.complete() // Complete the Observable
          } else {
            const parsed: Record<string, any> = {}
            for (const [k, v] of Object.entries(response)) {
              try { parsed[k] = typeof v === 'string' ? JSON.parse(v) : v } catch { parsed[k] = v }
            }
            observer.next(parsed) // Notify the observer that the operation is complete
            observer.complete() // Complete the Observable
          }
        }
      ).catch((error) => {
        observer.error(error) // Notify the observer of an error
      })
    })
  }
  removePost = (post_id: string) => {
    let project_id = this.builderService.selectedProject
    this.settingsApi.upsertSettingsByType(String(project_id), 'posts', { [post_id]: null as any })
  }

  getPost = (post_id: string) => {
    let project_id = this.builderService.selectedProject
    return new Observable<any>((observer) => {
      this.settingsApi.getSettingsByType(String(project_id), 'posts').then(
        (response) => {
          const raw = response[post_id]
          if (raw) {
            let parsed = raw
            try { if (typeof raw === 'string') parsed = JSON.parse(raw) } catch {}
            observer.next(parsed) // Notify the observer that the operation is complete
            observer.complete() // Complete the Observable
          } else {
            console.log('No data available')
            observer.next({})
            observer.complete() // Complete the Observable
          }
        }
      ).catch((error) => {
        observer.error(error) // Notify the observer of an error
      })
    })
  }
}
